import { useState } from "react";
import { useTranslation } from "react-i18next";
import TkElectrodeOrderPurchaseDetailOrderBuyCreateDialog from "../dialogTypes/TkElectrodeOrderPurchaseDetailOrderBuyCreateDialog";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

function TkElectrodeOrderPurchaseDetailOrderBuyCreateButton(props) {

    const { t } = useTranslation();

    const { id, schema, refresh, onSuccess, electrodeId, onSelectOrderBuy, createButtonName, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={createButtonName} {...others} />
            <TkElectrodeOrderPurchaseDetailOrderBuyCreateDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${schema.name}.create`) : ""}
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                electrodeId={electrodeId}
                onSuccess={onCreateSuccess}
                onSelectOrderBuy={onSelectOrderBuy}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default TkElectrodeOrderPurchaseDetailOrderBuyCreateButton;

